import React from 'react'

export const headed2SetupVars = {
  siteId: 'headed2',
  topScreenshotUrl: '/images/headed2/marketing/images/Mockup@2x.png',
  pathPrefix: '',
  menuHeader: 'Discover Our Solution for:',
  appUrl: 'https://app.headed2.com',
  appName: 'CareerExplorer',
  freeEducatorAccountQuota: 25,
  webinar: {},
  webinarHistory: [
    {
      date: 'December 2021',
      sortableDate: new Date('12/21/2021'),
      title: 'Secrets to Success for Free Educator Accounts in CareerZone',
      description:
        'So you have a free educator account, but you’re not sure you’re making the most of it. Watch this webinar to hear about best practices using the CareerZone and CareerExplorer and to hear about some exciting updates to the system coming in 2022.',
      videoUrl:
        'https://h2-training.s3.amazonaws.com/Secrets+to+Success+Free+Educator+Account+Webinar+2021.mp4'
    },
    {
      date: 'March 2021',
      sortableDate: new Date('3/1/2021'),
      title:
        'How to make the CareerZone/CareerExplorer your technology backbone for Career Readiness',
      description:
        'Watch our March 2021 webinar to learn how to use the CareerZone and CareerExplorer as your technology backbone for career readiness.',
      videoUrl:
        'https://h2-training.s3.amazonaws.com/How+to+make+the+CareerZone_CareerExplorer+your+technology+backbone+for+Career+Readiness.mp4'
    },
    {
      date: 'September 2020',
      sortableDate: new Date('9/1/2020'),
      title: 'Career Readiness Strategies for Remote Learning in 2020-2021',
      description:
        'Watch our September 2020 webinar to learn how to use the CareerZone and CareerExplorer in the remote learning context.',
      videoUrl:
        'https://h2-training.s3.amazonaws.com/Career+Readiness+Strategies+for+Remote+Learning+in+2020-2021.mp4'
    },
    {
      date: 'April 2020',
      sortableDate: new Date('4/1/2020'),
      title: 'A Free Lesson for Remote Learners and Career Exploration for Elementary',
      description:
        'Join us as we continue to share remote learning resources during the Covid19 crisis. Learn about a free introductory lesson now available in the CareerExplorer as well as Up the Ladder - our career game designed for elementary students.',
      videoUrl:
        'https://h2-training.s3.amazonaws.com/April+2020+Webinar-+Help+with+Remote+Learning+about+Careers+and+Up+the+Ladder+for+Elementary.mp4'
    },
    {
      date: 'March 2020',
      sortableDate: new Date('3/1/2020'),
      title: 'Mastering Lessons and Managing Career Plans',
      description:
        'Join us for a crash course in developing successful lessons and managing multi-step career planning inside the CareerExplorer',
      videoUrl:
        'https://h2-training.s3.amazonaws.com/Headed2+CareerZone+and+CareerExplorer+March+2020+Webinar-+Lessons+In+Depth.mp4'
    }
  ],
  logoImg: '/images/assets/headed2/horizontal/dark.svg',
  headerTitle: `The CareerExplorer by Headed2`,
  headerTitleDescription: (
    <div>
      <p>
        The CareerExplorer is a state of the art <b>career exploration</b> and{' '}
        <b>planning</b> tool designed to support career readiness.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  brochureDownloadImg: '/images/www/new/Homepage-Download-CE@2x.jpg',
  brochureDownloadUrl: `https://drive.google.com/uc?export=download&id=1psYjK0Bt11Lk-oEJb6XCuoCwSVhS3mVL`,
  featuresTitle: (
    <span>
      An upgraded <b>Headed2 Account</b> delivers premium features
    </span>
  ),
  features: [
    {
      cssClass: 'lesson-plans',
      title: 'Pre-populated lesson plans'
    },
    {
      cssClass: 'reporting-tools',
      title: 'Enhanced Reporting'
    },
    {
      cssClass: 'sso',
      title: 'Single Sign On (SSO) with Google, MS365, Clever'
    },
    {
      cssClass: 'local-opps',
      title: 'Local Opportunities Platform for Work-Based Learning'
    },
    {
      cssClass: 'prof-dev',
      title: 'Professional Development'
    },
    {
      cssClass: 'file-storage',
      title: 'Unlimited File Storage'
    }
  ],
  upgradeTitle: (
    <span>
      Get a <b>Headed2 Account</b> Today
    </span>
  ),
  sponsorMsg: (
    <span>
      The CareerExplorer aligns directly with most <b>state standards</b> to help{' '}
      <b>increase career readiness</b> for students across the country.
    </span>
  ),
  sponsorImg: null,
  featureSections: [
    {
      title: `Nevada State Library and Public Records Sponsored`,
      text: `The Nevada CareerExplorer is a career readiness and planning system sponsored by the NSLAPR to increase career readiness for youth and adults in Nevada. The CareerExplorer can be used by communities to scale career pathways, implement work-based learning and promote in-demand careers.`,
      imageUrl: `/images/nevada/marketing/images/Nevada_State_Library_and_Public_Records_Sponsored@2x.jpg`
    },
    {
      title: `Made for Nevada`,
      text: `Where the CareerExplorer shines is with its local job, wage and cost of living data. Youth and adults around the state will be able to learn about high-priority occupations, as well as those careers that are the fastest growing, highest paid and most employed.`,
      imageUrl: `/images/nevada/marketing/images/Made_for_Nevada@2x.jpg`
    },
    {
      title: `Individual Success Ready`,
      text: `Whether you are looking to help youth or adults develop or revise a Career Plan or you simply need a tool to help them implement that plan, the Nevada CareerExplorer is an ideal solution. Our ready-made lesson plans are easily assigned and tracked. Our data-rich system makes it possible to explore over 900 careers and many more college and post-secondary opportunities, including industry certifications.`,
      imageUrl: `/images/nevada/marketing/images/Individual_Success_Ready@2x.jpg`
    },
    {
      title: `Work-Based Learning Ready`,
      text: `Our “Local Opportunities Network” allows schools to promote, manage and coordinate work-based learning (WBL) opportunities among employers, students and teachers. Opportunities are promoted directly within career exploration and planning, providing a seamless system for career development and experiences. It is designed to serve as a single repository and database to plan, execute,manage and evaluate work-based learning initiatives across multiple employers, schools and program providers. The Local Opportunities Network takes the hassle out of coordinating engagement, keeping records and assembling reports manually.`,
      imageUrl: `/images/nevada/marketing/images/Work-Based_Learning_Ready@2x.jpg`
    },
    {
      title: `Up the Ladder was Made for Elementary`,
      text: `The CareerExplorer upgrade includes "Up the Ladder" a system designed for elementary students.  When you upgrade the CareerExplorer, you can easily run reports on evidence generated in "Up the Ladder".`,
      imageUrl: `/images/nevada/marketing/images/UpTheLadder@2x.jpg`
    }
  ],
  contactFormHeader: `Talk to Our Partner Team`,
  contactFormDescription: `Our team is standing by and ready to demo the Nevada CareerExplorer for your organization. You can also check out these videos to learn more about what our system offers.`,
  introducingImg: `/images/headed2/marketing/H2-NV-OneSheet-0619-V1.8_Introducing.jpg`,
  introducingUrl: `https://drive.google.com/uc?export=download&id=1LudOUeNP_rYaxrGHR9zFDZRFUpEyisjX`,
  otherSites: [
    {
      url: 'https://www.cacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/CCZ-logo.svg'
    },
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
